import styled from 'styled-components';

import ResizeBar from './components/ResizeBar';
import TabBar from './components/TabBar/TabBar';
import useRightSideBar from './hooks/useRightSideBar';
import NodeInfoViewer from './components/NodeInfoViewer';
import CodeViewer from './components/CodeViewer/CodeViewer';
import HyperparameterViewer from './components/HyperparameterViewer/HyperparameterViewer';
import useRightSideBarFull from 'pages/Editor/hooks/useRightSideBarFull';

const Container = styled.div<{ $isFull: boolean }>`
  position: relative;
  height: 100%;
  display: flex;
  ${(props) => {
    if (props.$isFull) {
      return {
        flex: 1,
        overflow: 'hidden',
      };
    }
  }}
`;

const RelativeViewer = styled.div`
  position: relative;
  display: flex;
  flex: 1;
  overflow: hidden;
`;

const Content = styled.div`
  flex: 1;
  height: 100%;
  position: relative;
  overflow: auto;
`;

const RightSideBar = () => {
  const { isFullAndSelected } = useRightSideBarFull();
  const { selectedTab, width, onMouseDown } = useRightSideBar();

  return (
    <Container $isFull={isFullAndSelected}>
      {selectedTab && (
        <>
          {!isFullAndSelected && <ResizeBar onMouseDown={onMouseDown} />}
          <RelativeViewer>
            <Content {...(!isFullAndSelected && { style: { minWidth: `${width}px`, width: `${width}px` } })}>
              {selectedTab === 'nodeInfo' && <NodeInfoViewer />}
              {selectedTab === 'code' && <CodeViewer />}
              {selectedTab === 'hyperparameter' && <HyperparameterViewer />}
            </Content>
          </RelativeViewer>
        </>
      )}
      <TabBar />
    </Container>
  );
};

export default RightSideBar;
